module.exports = __webpack_public_path__ + "static/media/dark-add.7bddb284.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dark-add.svg
// module id = 2371
// module chunks = 7